import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import NontAuthorized401 from "NontAuthorized401";
import TemplateManager from "./components/TemplateManager";

const SmsPhoneTemplate = () => {
  const hasToken = Boolean(localStorage.getItem("Token"));

  if (!hasToken) {
    return <NontAuthorized401 />;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <TemplateManager
        channel="sms-phone"
        badgeText="SMS / Phone Templates"
        heading="SMS / Phone Notification Templates"
        description="Make simple SMS messages and phone call scripts your team can save and use later."
        subjectLabel="Template Title"
        bodyLabel="Message / Call Script"
        bodyPlaceholder="Example: Your booking is tomorrow at 11 AM."
        simpleHelpText="Choose SMS or Phone, type template name, add title, write message, and click Save Template."
      />
    </DashboardLayout>
  );
};

export default SmsPhoneTemplate;
